<div class="container">
  <div class="message text-mat-ef-revolution-primary-500">
    @if (snackBarData.translationKey) {
      <div>
        @if (isArray) {
          <div>
            @for (key of snackBarData.translationKey; track key) {
              <div>
                {{ getTranslation(key) }}
              </div>
            }
          </div>
        }
        @if (!isArray) {
          <div>
            {{ getTranslation(snackBarData.translationKey) }}
          </div>
        }
      </div>
    }

    @if (snackBarData.text) {
      <div>{{ snackBarData.text }}</div>
    }
  </div>
  @if (snackBarData.action) {
    <div class="action">
      <button data-cy="snackbar-close-button" mat-button (click)="snackBar.dismiss()">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  }
</div>
